import LoginComponent from "../components/Login.vue"
import SecureComponent from "../components/Secure.vue"
import UserFormularComponent from "../components/UserFormular.vue";


export default [
    {
        path: "login",
        name: "login",
        alias: "/",
        component: LoginComponent
    },
    {
        path: "formular",
        name: "formular",
        component: UserFormularComponent
    },
    {
        path: "secure",
        name: "secure",
        component: SecureComponent,
        meta: { requiresAuth: true }
    }
]